import React, { useEffect, useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';
import { Grid, SpeedDialAction, SpeedDialIcon, SpeedDial, Card, CardContent } from '@mui/material';
import { useParams } from 'react-router-dom';
import { Page, Header, Alert } from 'components';
import { Sync } from '@mui/icons-material';
import UploadIcon from '@mui/icons-material/Upload';
import _ from 'underscore';

import KpisUploadDialog from './components/KpisUploadDialog';
import KpiUploadProcessTable from './components/KpiUploadProcessTable';

import { GetTreeLastUpdate, SyncFtpTree, ToggleKpisUploadDialog, GetKpiProcessTable } from '../actions/DriveTestUploadActions.js';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(1),
	},
	tabs: {
		marginTop: theme.spacing(1),
	},
	content: {
		marginTop: theme.spacing(1),
	},
}));

const actions = [
	{ icon: <Sync />, name: 'Sync FTP File Tree', id: 'syncTree' },
	{ icon: <UploadIcon />, name: 'Upload Kpis From FTP', id: 'uploadKpis' },
];

const DriveTestUpload = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const userId = useSelector(state => state.session.user.id);
	const treeLastUpdate = useSelector((state) => state.driveTestUploadReducer.treeLastUpdate);
	const kpisUploadDialogVisibility = useSelector((state) => state.driveTestUploadReducer.kpisUploadDialogVisibility);
	const kpiProcessTable = useSelector((state) => state.driveTestUploadReducer.kpiProcessTable);

	useEffect(() => {
		dispatch(GetTreeLastUpdate());
		dispatch(GetKpiProcessTable());
	}, []);

	const _handleSpeedDialClick = (action) => {
		if (action.id === 'syncTree') {
			dispatch(SyncFtpTree(userId));
		} else if (action.id === 'uploadKpis') {
			dispatch(ToggleKpisUploadDialog(true));
		}
	};

	const _kpisUploadDialogClose = (event, reason) => {
		if (reason !== 'backdropClick') {
			dispatch(ToggleKpisUploadDialog(false));
		}
	};

	return (
		<Page className={classes.root} title="Drive Test Upload">
			<Header
				module="Modules"
				view="Drive Test Upload"
			/>
			<SpeedDial
				ariaLabel="SpeedDial"
				sx={{ position: 'absolute', bottom: 16, right: 16 }}
				icon={<SpeedDialIcon />}
			>
				{actions.map((action) => (
					<SpeedDialAction
						key={action.name}
						icon={action.icon}
						tooltipTitle={action.name}
						onClick={() => { _handleSpeedDialClick(action); }}
					/>
				))}
			</SpeedDial>
			<Alert
				className={classes.container}
				variant="info"
				message={_.isUndefined(treeLastUpdate) ? 'Tracker date unavailable!' : treeLastUpdate}
			/>
			<br />
			<Card className={classes.container}>
				<CardContent>
					<Grid item lg={12} xs={12}>
						<KpiUploadProcessTable className={classes.results} data={kpiProcessTable} />
					</Grid>
				</CardContent>
			</Card>
			{kpisUploadDialogVisibility && (
				<KpisUploadDialog
					onClose={_kpisUploadDialogClose}
					open={kpisUploadDialogVisibility}
				/>
			)}
		</Page>
	);
};

export default DriveTestUpload;
